import PropTypes from 'prop-types'
import React from 'react'
import cx from 'classnames'
import './style.css'

const TitleCard = ({ title, subtitle, className, children }) => (
  <div className={cx("onboarding-title-card", className)}>
    <div className="onboarding-title-card-header">
      <div className="onboarding-title-card-title">{ title }</div>
      <div className="onboarding-title-card-subtitle">{ subtitle }</div>
    </div>
    <div className="onboarding-title-card-content">
      { children }
    </div>
  </div>
)
TitleCard.propTypes = {
  title: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
}

export default TitleCard


// WEBPACK FOOTER //
// ./src/components/OnboardingTitleCard/index.js